import { render } from "./Bell.vue?vue&type=template&id=410f3ef8&scoped=true"
import script from "./Bell.vue?vue&type=script&lang=js"
export * from "./Bell.vue?vue&type=script&lang=js"

import "./Bell.vue?vue&type=style&index=0&id=410f3ef8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-410f3ef8"]])

export default __exports__